import React from 'react';
import classes from "../Styling/SharedStyling.module.css";
import sample from '../Images/Website_Loop_2023.mp4';
import BottomLinkBar from './BottomLinkBar';

export default function HomePage()
{
  document.body.style.backgroundImage = "linear-gradient(to right, rgba(44,44,44,1), rgba(10,10,10,1))";

  return (
    <body>
      <div className={classes.fullScreenCenteredContainer}>
        <video autoPlay loop muted playsInline>
          <source src={sample} type='video/mp4' />
        </video>
        <div className={classes.centered}>
          <div className={classes.name}>kyle keirstead</div>
        </div>
      </div>
      <BottomLinkBar />
    </body>

  );
}
